import { useCallback, useEffect, useState } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { getDisciplineName } from '../../../../core/utils/discipline';
import { ContentList } from '../../components/DailySchedule/ContentList';
import { PAEssayPage } from '../../components/DailySchedule/EssayPage';
import { PAExercisePage } from '../../components/DailySchedule/ExercisePage';
import LessonPage from '../../components/DailySchedule/LessonPage';
import { PAMaterialPage } from '../../components/DailySchedule/MaterialPage';
import { useGetScheduleEssayThemeHook } from '../../hooks/EssaySchedule/useGetScheduleEssayThemeHook';
import { useDailyScheduleContentStore } from '../../stores/useDailyScheduleContent';
import './style.css';
import { useParams } from 'react-router-dom';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';
import { Icon } from '../../../../core/components/atoms/Icon';
import {
  AbcIcon,
  BeakerIcon,
  CalculatorIcon,
  DnaIcon,
  EnglishIcon,
  OwlIcon,
  MoleculeIcon,
  GlobeIcon,
  PencilIcon,
  SpanishIcon,
  TempleIcon,
  CornerstoneIcon,
} from 'morpheus-ui';

export default function DaySchedule() {
  const { scheduleId } = useParams();
  const { mutate, isPending } = useGetScheduleEssayThemeHook();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const selectedContent = useDailyScheduleContentStore(
    (state) => state.selectedContent
  );

  const selectedDiscipline = useDailyScheduleContentStore(
    (state) => state.selectedDiscipline
  );

  const selectedDay = useDailyScheduleContentStore(
    (state) => state.selectedDay
  );

  useEffect(() => {
    if (
      selectedDiscipline === 'redacao' &&
      selectedDay &&
      selectedContent?.type === 'essay'
    ) {
      const formattedDate = selectedDay.subtitle
        ? selectedDay.subtitle.split('/').reverse().join('-')
        : '';
      mutate({
        day: formattedDate,
        scheduleId: scheduleId || '',
        essayContentId: selectedContent.content.id,
      });
    }
  }, [selectedDiscipline, selectedDay, selectedContent]);

  const Component = () => {
    const compoents = {
      lesson: <LessonPage />,
      essay: <PAEssayPage />,
      material: <PAMaterialPage />,
      exercise: <PAExercisePage />,
    };

    return (
      compoents[selectedContent?.type as keyof typeof compoents] || (
        <BrainLoadingWrapper />
      )
    );
  };

  const slug = selectedContent?.content?.slug_area;

  const collapseIcon = useCallback(() => {
    if (isSidebarOpen) return;

    const disciplines = {
      redacao: (
        <PencilIcon className='h-6 w-6 font-bold text-mono-color-darker  ' />
      ),
      ingles: (
        <EnglishIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      espanhol: (
        <SpanishIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      matematica: (
        <CalculatorIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      portugues: (
        <PencilIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      biologia: (
        <DnaIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      fisica: (
        <MoleculeIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      quimica: (
        <BeakerIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      historia: (
        <CornerstoneIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      geografia: (
        <GlobeIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      filosofia: (
        <OwlIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      sociologia: (
        <TempleIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
      literatura: (
        <AbcIcon className='h-6 w-6 font-bold text-mono-color-darker' />
      ),
    };

    return disciplines[slug as keyof typeof disciplines] || undefined;
  }, [selectedContent?.content, isSidebarOpen]);

  return (
    <div className='flex h-full w-full gap-8 '>
      <div className='bg-brand-color-primary contentBox h-auto flex-1 overflow-y-auto transition-all duration-300'>
        <div className=' rounded-[32px] p-5 md:bg-mono-color-white'>
          <Component />
        </div>
      </div>

      <div
        style={{ width: isSidebarOpen ? undefined : '100px' }}
        className={`contentBox  top-4 hidden h-fit max-h-[calc(100vh-2rem)] rounded-[32px] bg-mono-color-white lg:block ${isSidebarOpen ? 'w-1/3' : '!h-14'} shrink-0 transition-all duration-300`}
      >
        <div
          className={`flex h-full flex-col gap-xl ${isSidebarOpen ? 'p-7' : 'p-4 '}`}
        >
          <div
            className={`flex cursor-pointer items-center ${isSidebarOpen || !!collapseIcon() ? 'justify-between' : 'justify-center'}`}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen && (
              <Typography size='h2' type='title'>
                {getDisciplineName(selectedDiscipline)}
              </Typography>
            )}
            {collapseIcon()}
            <Icon
              type='material'
              Icon={isSidebarOpen ? 'chevron_left' : 'chevron_right'}
              className='cursor-pointer text-mono-color-darker'
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            />
          </div>
          <div
            className={`${isSidebarOpen ? '' : 'hidden'}  max-h-[calc(100vh-250px)] overflow-y-auto`}
          >
            <ContentList />
          </div>
        </div>
      </div>
    </div>
  );
}
